<span
  class="tag"
  [class.error]="variant() === tagVariant.Error"
  [class.warning]="variant() === tagVariant.Warning"
  [class.info]="variant() === tagVariant.Info"
  [class.success]="variant() === tagVariant.Success"
  [class.attention]="variant() === tagVariant.Attention"
  [class.high-alert]="variant() === tagVariant.HighAlert"
  [class.elevated]="variant() === tagVariant.Elevated"
  [class.audit]="variant() === tagVariant.Audit"
  [class.hot-weather]="variant() === tagVariant.HotWeather"
  [class.cold-weather]="variant() === tagVariant.ColdWeather"
  [class.sm]="size() === 'sm'"
>
  {{ label() }}
</span>
